import { render, staticRenderFns } from "./inviteUserModal.vue?vue&type=template&id=2955a69e&scoped=true"
import script from "./inviteUserModal.vue?vue&type=script&lang=js"
export * from "./inviteUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2955a69e",
  null
  
)

export default component.exports